export const ADMIN_GROUP = 'admin'
export const SUPPORT_GROUP = 'support'
export const SUPPORT_ADMIN_GROUP = 'support-admin'

export const CRISP_MONITORING_PERMISSION = 'can_access_conversation_details'
export const CONVERSATIONS_STATS_PERMISSION = 'can_access_conversation_stats'
export const CRISP_UNLOCK_EMAIL_PERMISSION = 'can_unlock_email'
export const CAN_ACCESS_EXTERNAL_REVIEW_CODENAME = 'can_access_external_review'
export const CAN_UNLOCK_EXTERNAL_REVIEW_CODENAME = 'can_unlock_external_review'

// Page « Test pipeline IA » : accès par liste blanche d'emails, indépendante des
// groupes/permissions du back (la carte ET la route sont filtrées dessus).
export const AI_PIPELINE_TEST_PERMISSION = 'ai_pipeline_test'
export const AI_PIPELINE_TEST_ALLOWED_EMAILS = ['axelbluss@gmail.com', 'louis@jmny.eu']
